import { CSSProperties, FC } from "react";
import {
	NOTIFICATION_CATEGORIES,
	NOTIFICATION_CATEGORY_ORDER,
	NOTIFICATION_CATEGORY_STYLES,
} from "../../../constants/notificationConstant";
import { iNotificationCentreCounts, iNotificationFilter } from "../../../types/notificationTypes";
import "./notificationFilters.scss";

interface iNotificationFiltersProps {
	filter: iNotificationFilter;
	counts: iNotificationCentreCounts | null;
	onChange: (filter: iNotificationFilter) => void;
	variant: "popover" | "page";
}

const withCount = (label: string, count?: number) => (count ? `${label} (${count})` : label);

const NotificationFilters: FC<iNotificationFiltersProps> = ({ filter, counts, onChange, variant }) => {
	const isAll = !filter.category && !filter.unreadOnly;

	const setCategory = (category: NOTIFICATION_CATEGORIES) =>
		onChange({ ...filter, category: filter.category === category ? null : category });

	return (
		<div className={`notification_chips notification_chips_${variant}`}>
			<button
				type="button"
				className={`notification_chip ${isAll ? "active" : ""}`}
				onClick={() => onChange({ category: null, unreadOnly: false })}
			>
				All
			</button>
			<button
				type="button"
				className={`notification_chip ${filter.unreadOnly ? "active" : ""}`}
				onClick={() => onChange({ ...filter, unreadOnly: !filter.unreadOnly })}
			>
				{withCount("Unread", counts?.all?.unread)}
			</button>
			{NOTIFICATION_CATEGORY_ORDER.map((category) => (
				<button
					key={category}
					type="button"
					className={`notification_chip ${filter.category === category ? "active" : ""}`}
					style={{ "--notification-icon": NOTIFICATION_CATEGORY_STYLES[category].icon } as CSSProperties}
					onClick={() => setCategory(category)}
				>
					<span className="notification_chip_dot" aria-hidden />
					{withCount(NOTIFICATION_CATEGORY_STYLES[category].label, counts?.all?.byCategory?.[category])}
				</button>
			))}
			{variant === "page" && !isAll && (
				<button
					type="button"
					className="notification_clear_filter"
					onClick={() => onChange({ category: null, unreadOnly: false })}
				>
					Clear filter
				</button>
			)}
		</div>
	);
};

export default NotificationFilters;
